import React from 'react';

import { IconBaseProps } from 'src/ui-models/Icon';
import IconBase from '../icon-base/IconBase';

const LowBloodSugarIcon: React.FC<IconBaseProps> = ({ width = 24, height = 24, color = 'currentColor' }) => {
  return (
    <IconBase color={color} width={width} height={height}>
      <path
        d="M14.0005 5.0007C13.4405 5.0007 13.0005 5.4507 13.0005 6.0007V11.5907L2.12047 0.700703C1.73047 0.310703 1.10047 0.310703 0.710469 0.700703C0.320469 1.0907 0.320469 1.7207 0.710469 2.1107L11.5905 13.0007H6.00047C5.45047 13.0007 5.00047 13.4507 5.00047 14.0007C5.00047 14.5507 5.45047 15.0007 6.00047 15.0007H14.0005C14.5505 15.0007 15.0005 14.5507 15.0005 14.0007V6.0007C15.0005 5.4507 14.5505 5.0007 14.0005 5.0007Z"
        fill={color}
      />
    </IconBase>
  );
};

export default LowBloodSugarIcon;
